import { Button, ButtonProps } from "antd";
import { forwardRef } from "react";
import styles from "./index.module.less";

function RawHBButton({ className, shape, ...props }: ButtonProps, ref) {
  return (
    <Button
      {...props}
      className={`${styles.HBButton} ${className} ${
        shape === "circle" ? styles.circle : ""
      }`}
      shape={shape}
      ref={ref}
    />
  );
}

const HBButton = forwardRef(RawHBButton);

export default HBButton;
